import { gql } from '@apollo/client'

export const CHAIN_FEE = gql`{ chainFee }`
